<div class="empty">
	<dsy-heading level="h3" level-size="xl" level-style="light">{{ titleSignal() }}</dsy-heading>

	@if (showPermissionStatusSignal()) {
	<dsy-heading level="h4" level-size="base" level-style="light">{{ permissionTextSignal() }}</dsy-heading>
	}
</div>